import fetchMfgLookup from 'api/fetchMfgLookup';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTotalCount, setMfgLookupList } from 'redux/modules/mfgLookup/slice';
import { getMfgLookup } from 'selectors';
import isEmptyArray from 'utils/isEmptyArray';

const useMfgLookup = () => {
  const dispatch = useDispatch();
  const state = useSelector(getMfgLookup);
  const [loading, setLoading] = useState(false);
  const { mfgLookupList, currentPage, pageSize, filter, reset } = state;

  const getList = () => {
    fetchMfgLookup(currentPage, pageSize, filter)
      .then((result) => {
        setLoading(false);
        if (result) {
          dispatch(setMfgLookupList(result.response));
          // dispatch(setCurrentPage(result.currentCount));
          dispatch(setTotalCount(result.totalCount));
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    console.log(`useEffect mount`);

    if (isEmptyArray(mfgLookupList)) {
      setLoading(true);
      getList();
    }
  }, []);

  useEffect(() => {
    console.log(`useEffect update`, currentPage, pageSize);
    setLoading(true);
    getList();
  }, [filter,currentPage, pageSize]);

  useEffect(() => {
    if (reset) {
      setLoading(true);
      getList();
    }
  }, [reset]);
  return loading;
};

export default useMfgLookup;
